import "lity/dist/lity";
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

// Sticky Menu on Platform top level page

const navLinks = gsap.utils.toArray(".side-anchor");

navLinks.forEach((a, index) => {
	let href = a.getAttribute("href");
	a.addEventListener("click", () => {
		gsap.to(window, {
			duration: 0.15,
			scrollTo: { y: href, offsetY: 200 },
		});
	});
});

const globalAlert = document.getElementById("sideGlobalAnnouncement");
const siteHeader = document.getElementById("siteNav");
const siteBody = document.getElementById("primary");

/**
* Get the value of a cookie
* Source: https://gist.github.com/wpsmith/6cf23551dd140fb72ae7
* @param  {String} name  The name of the cookie
* @return {String}       The cookie value
*/

function getCookie(name) {
	let value = `; ${document.cookie}`;
	let parts = value.split(`; ${name}=`);
	if (parts.length === 2) return parts.pop().split(";").shift();
}

if (globalAlert) {

	const sideGlobalAnnnouncementCookie = getCookie("sideGlobalAnnnouncement");
	if (sideGlobalAnnnouncementCookie == "closed") {
		// nothing
	} else {
		globalAlert.classList.remove("d-none");
		siteHeader.classList.add("includes-announcement-bar");
		siteBody.classList.add("adjust-for-announcement-bar");
	}

	globalAlert.addEventListener("closed.bs.alert", function () {
		document.cookie = `sideGlobalAnnnouncement=closed; path=/; max-age=${60 * 60 * 24 * 14
			}; Secure`;
		siteBody.classList.remove("adjust-for-announcement-bar");
		siteHeader.classList.remove("includes-announcement-bar");
	});

}

// Save UTMs as cookies and then populate gravity forms
// Get the URL query string
const queryString = window.location.search;

// Check if the query string contains any UTM parameters
if (queryString.indexOf("utm_") !== -1) {
	// Parse the query string into an object
	const params = new URLSearchParams(queryString);

	// Loop through the UTM parameters and save them in a cookie
	params.forEach(function (value, key) {
		if (key.startsWith("utm_")) {
			// Set the cookie name, value, and expiration date (14 days)
			let cookieName = "side_" + key;
			let cookieValue = value;
			let cookieExpires = new Date();
			cookieExpires.setDate(cookieExpires.getDate() + 14);

			// save the cookie
			document.cookie = `${cookieName}=${cookieValue}; path=/; max-age=${60 * 60 * 24 * 14
				}; Secure`;
		}
	});
}
// Get all the Gravity Forms form elements
const forms = document.querySelectorAll(".gform_wrapper form");

// Loop through each form element
forms.forEach(function (form) {

	// all cookies
	const utmSourceCookie = getCookie("side_utm_source");
	const utmMediumCookie = getCookie("side_utm_medium");
	const utmCampaignCookie = getCookie("side_utm_campaign");
	const utmTermCookie = getCookie("side_utm_term");
	const utmContentCookie = getCookie("side_utm_content");

	// all fields
	let utmContentField = form.querySelector("[name='input_9']");
	let utmMediumField = form.querySelector("[name='input_10']");
	let utmCampaignField = form.querySelector("[name='input_11']");
	let utmTermField = form.querySelector("[name='input_12']");
	let utmSourceField = form.querySelector("[name='input_13']");

	// if #gform_14 use these values instead
	if (form.id == 'gform_14') {
		utmContentField = form.querySelector("[name='input_120']");
		utmMediumField = form.querySelector("[name='input_119']");
		utmCampaignField = form.querySelector("[name='input_121']");
		utmTermField = form.querySelector("[name='input_123']");
		utmSourceField = form.querySelector("[name='input_122']");
	}

	if (utmSourceCookie && utmSourceField) {
		utmSourceField.value = utmSourceCookie;
	}

	if (utmMediumCookie && utmMediumField) {
		utmMediumField.value = utmMediumCookie;
	}

	if (utmCampaignCookie && utmCampaignField) {
		utmCampaignField.value = utmCampaignCookie;
	}

	if (utmTermCookie && utmTermField) {
		utmTermField.value = utmTermCookie;
	}
	if (utmContentCookie && utmContentField) {
		utmContentField.value = utmContentCookie;
	}
});

// THIS NEEDS CLEANUP

(function ($) {
	$(document).ready(function () {
		// Hero Banner JS

		// Add Ready Listener for each Vidyard video for the Video Modals
		function playVideoInModal(modalID, UUID) {
			vidyardEmbed.api.addReadyListener((_, player) => {
				$(modalID).on('show.bs.modal', function () {
					player.play();
					if ($(this).hasClass('modal--smoothscroll')) {
						let sectionOffsetTop = $(this).parent().offset().top - 100;
						// console.log(sectionOffsetTop);
						$([document.documentElement, document.body]).scrollTop(sectionOffsetTop);

					}
				})

				$(modalID).on('hide.bs.modal', function () {
					player.pause();
				})
			}, UUID)
		}

		// When VidYard API is loaded
		window.onVidyardAPI = (vidyardEmbed) => {
			// for each Modal with Video, get the modal ID & UUID
			$('.modal--with-video').each(function () {
				const vidyardModalID = "#" + $(this).attr('id');
				const vidayrdModalUUID = $(this).find('.vidyard-player-embed').data('uuid');

				// Then playVideoInModal
				if (vidyardModalID && vidayrdModalUUID) {
					playVideoInModal(vidyardModalID, vidayrdModalUUID);
				}
			});
		}
	});

})(jQuery);